import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectFade, Autoplay, Lazy } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/lazy'
import { to1200Image } from '~/utils'
import Navigation from './Navigation'
import classNames from 'classnames'
import styles from './index.module.css'

export interface ImageType {
  url: string
  width?: number
  height?: number
}
type IProps = {
  previewImages: ImageType[]
  autoplay?: boolean
  className?: string
  effect?: any
  modules?: any[]
  lazy?: boolean
}

const ImageViewer = ({
  previewImages,
  autoplay = false,
  className,
  effect = 'fade',
  modules = [EffectFade, Autoplay, Lazy],
  lazy = true,
}: IProps) => {
  return (
    <>
      <Swiper
        className={classNames(
          styles.swiper,
          {
            hasNav: previewImages.length > 1,
          },
          className
        )}
        effect={effect}
        loop={true}
        lazy={lazy}
        autoplay={
          autoplay
            ? {
                delay: 1000,
                // 此处为了兼容下载原图：鼠标上移时中断轮播
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
              }
            : false
        }
        modules={modules}
        fadeEffect={{ crossFade: true }}
        allowTouchMove={false}
      >
        {previewImages.map(it => (
          <SwiperSlide key={it.url}>
            <div className="relative h-full w-full">
              <img
                className="swiper-lazy"
                data-src={to1200Image(it.url)}
                alt=""
              />
            </div>
          </SwiperSlide>
        ))}
        {previewImages.length > 1 && <Navigation images={previewImages} />}
      </Swiper>
    </>
  )
}

export default ImageViewer
